import React from "react";
import PropTypes from "prop-types";

import SPACING from "shared/config/spacing";
import { StyledHStack } from "./HStack.styles";

const HStack = React.forwardRef(
    ({ spacing, wrap, align, justify, ...props }, ref) => {
        return (
            <StyledHStack
                $spacing={spacing}
                $wrap={wrap}
                $align={align}
                $justify={justify}
                {...props}
                ref={ref}
            />
        );
    }
);

HStack.defaultProps = {
    spacing: SPACING.One,
    wrap: false,
};

HStack.propTypes = {
    spacing: PropTypes.oneOf(Object.keys(SPACING)),
    wrap: PropTypes.bool,
    align: PropTypes.string,
    justify: PropTypes.string,
};

export default HStack;
